export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        value: []
    },
    setting: {
        logic: ['match', 'oneof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game'],
        self: true
    },
    lang: {
        name: 'Inventory Location',
        category: ['User', 'Collection'],
        description: 'Where game was labelled as being located.',
        summarise: {
            prefix: 'Inventory location'
        },
        unit: 'location'
    }
}